<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>采购组织：</span>
        <span>{{ item.purorgName }}</span>
      </van-row>
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>供货品类：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row>
        <span>供应商编号：</span>
        <span>{{ item.suppId }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>原配额(%)：</span>
        <span>{{ item.originalQuota }}</span>
      </van-row>
      <van-row>
        <span>调整后配额(%)：</span>
        <span>{{ item.quota }}</span>
      </van-row>
      <van-row>
        <span>起始日期：</span>
        <span>{{ item.startDate }}</span>
      </van-row>
      <van-row>
        <span>结束日期：</span>
        <span>{{ item.endDate }}</span>
      </van-row>
      <van-row>
        <span>拆分配额的最小数量：</span>
        <span>{{ item.minQuotaQty }}</span>
      </van-row>
      <van-row>
        <span>单元包装量：</span>
        <span>{{ item.bstrf }}</span>
      </van-row>
      <van-row>
        <span>最小起订量：</span>
        <span>{{ item.minRcvQty }}</span>
      </van-row>
      <van-row>
        <span>是否启用分割：</span>
        <span>{{ item.isQuotaSplit | dictFilter(isQuotaSplitDictOptions) }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'MaterialDetails',
  data() {
    return {}
  },
  props: {
    detailsList: {
      type: Array,
      required: true
    }
  },
  computed: {
    isQuotaSplitDictOptions() {
      return this.$store.getters.dicts.yes_no
    }
  }
}
</script>
